export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL;
